"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectFixedStreamStatus = exports.selectFixedStreamShortInfo = exports.selectFixedStreamData = exports.selectFixedExtremes = exports.selectFetchedTimeRanges = exports.selectStreamMeasurements = exports.selectLastSelectedFixedTimeRange = exports.selectIsLoading = exports.selectFixedData = exports.selectFixedStreamState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const moment_1 = __importDefault(require("moment"));
const dateFormat_1 = require("../types/dateFormat");
const lastArrayItem_1 = require("../utils/lastArrayItem");
const measurementsCalc_1 = require("../utils/measurementsCalc");
const selectFixedStreamData = (state) => {
    return state.fixedStream.data;
};
exports.selectFixedStreamData = selectFixedStreamData;
const selectFixedStream = (state) => state.fixedStream;
const selectFixedExtremes = (0, toolkit_1.createSelector)([selectFixedStream], (fixedStream) => {
    const { averageMeasurementValue, minMeasurementValue, maxMeasurementValue, } = fixedStream;
    const min = (0, measurementsCalc_1.isValidValue)(minMeasurementValue)
        ? Math.round(minMeasurementValue)
        : null;
    const max = (0, measurementsCalc_1.isValidValue)(maxMeasurementValue)
        ? Math.round(maxMeasurementValue)
        : null;
    const avg = (0, measurementsCalc_1.isValidValue)(averageMeasurementValue)
        ? Math.round(averageMeasurementValue)
        : null;
    return {
        minMeasurementValue: min,
        maxMeasurementValue: max,
        averageValue: avg,
    };
});
exports.selectFixedExtremes = selectFixedExtremes;
const selectLastDailyAverage = (state) => {
    const { streamDailyAverages } = selectFixedStreamData(state);
    return (0, lastArrayItem_1.lastItemFromArray)(streamDailyAverages);
};
const selectFixedStreamShortInfo = (0, toolkit_1.createSelector)([selectFixedStreamData, selectLastDailyAverage], (fixedStreamData, lastDailyAverage) => {
    const { value: lastMeasurementValue, date } = lastDailyAverage || {};
    const lastMeasurementDateLabel = (0, moment_1.default)(date).format("MMM D");
    const lastUpdate = moment_1.default
        .utc(fixedStreamData.stream.endTime)
        .format("HH:mm MMM D YYYY");
    const startTime = moment_1.default
        .utc(fixedStreamData.stream.startTime)
        .format(dateFormat_1.DateFormat.us_with_time);
    const endTime = moment_1.default
        .utc(fixedStreamData.stream.endTime)
        .format(dateFormat_1.DateFormat.us_with_time);
    const active = fixedStreamData.stream.active;
    const { min, low, middle, high, max } = fixedStreamData.stream;
    const sortedStreamDailyAverages = [
        ...fixedStreamData.streamDailyAverages,
    ].sort((a, b) => (0, moment_1.default)(b.date).valueOf() - (0, moment_1.default)(a.date).valueOf());
    const newestAverageObject = sortedStreamDailyAverages[0];
    const newestAverageValue = newestAverageObject
        ? Number(newestAverageObject.value)
        : 0;
    const newestDate = sortedStreamDailyAverages.length > 0
        ? moment_1.default.utc(Math.max(...sortedStreamDailyAverages.map((m) => Number(m.date))))
        : (0, moment_1.default)();
    const newestDayMeasurements = sortedStreamDailyAverages.filter((m) => (0, moment_1.default)(Number(m.date)).isSame(newestDate, "day"));
    const maxMeasurementValue = Math.max(...newestDayMeasurements.map((m) => m.value));
    const minMeasurementValue = Math.min(...newestDayMeasurements.map((m) => m.value));
    return Object.assign(Object.assign({}, fixedStreamData.stream), { lastMeasurementValue,
        lastMeasurementDateLabel,
        lastUpdate,
        active,
        min,
        low,
        middle,
        high,
        max,
        minMeasurementValue,
        maxMeasurementValue, averageValue: newestAverageValue, startTime,
        endTime, latitude: fixedStreamData.stream.latitude, longitude: fixedStreamData.stream.longitude });
});
exports.selectFixedStreamShortInfo = selectFixedStreamShortInfo;
const selectFixedStreamStatus = (state) => state.fixedStream.status;
exports.selectFixedStreamStatus = selectFixedStreamStatus;
const selectFixedStreamState = (state) => state.fixedStream;
exports.selectFixedStreamState = selectFixedStreamState;
exports.selectFixedData = (0, toolkit_1.createSelector)([exports.selectFixedStreamState], (fixedStream) => fixedStream.data);
exports.selectIsLoading = (0, toolkit_1.createSelector)([exports.selectFixedStreamState], (fixedStream) => fixedStream.isLoading);
exports.selectLastSelectedFixedTimeRange = (0, toolkit_1.createSelector)([exports.selectFixedStreamState], (fixedStream) => fixedStream.lastSelectedTimeRange);
exports.selectStreamMeasurements = (0, toolkit_1.createSelector)([
    exports.selectFixedStreamState,
    (_state, streamId) => streamId,
], (fixedStream, streamId) => {
    return streamId ? fixedStream.data.measurements || [] : [];
});
exports.selectFetchedTimeRanges = (0, toolkit_1.createSelector)([
    (state) => state.fixedStream.fetchedTimeRanges,
    (_, streamId) => streamId,
], (fetchedTimeRanges, streamId) => fetchedTimeRanges[streamId] || []);
